// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"ko-z","badgeLink":"lo-z","category":"mo-z"};